
class SignUpUtility{
    static signupClient(clientInfo){
        //TO DO ...
    }

    static signupAdmin(adminInfo){
        //TO DO ...
    }
}

export default SignUpUtility;